import React from 'react'
import { Typography } from 'antd'

const Logo = () => (
  <Typography.Text strong>
    <i>AutoEat - FoodStyles</i>
  </Typography.Text>
)
export default Logo
